import $ = require('jquery');
import Modul from '../../Modul';
import l10n = require('diy/util/l10n');
/**
 * Module overlayWrapper
 *
 * Author: gpopescu
 */

    interface Options {
        thickness?: number;
        appendTo?: string;
        showToolbox?: boolean;
        addPadding?: number;
        toolbox?: {
            disabledButtons: string[];
        };
    }

    interface Size {
        width: number;
        height: number;
    }

    export default class ModuleOverlay {
        /**
         * @desc just blurRadius defined and use atm
         * @type {Object} css broken down shadow properties
         */
        static overlayShadowProperties = {
            //offsetX: 0,
            //offsetY: 0,
            blurRadius: 4
            //,spreadRadius: 0
        };
        static defaultOptions: Options = {
            thickness: 12,
            appendTo: 'body',
            showToolbox: true,
            addPadding: 0,
            toolbox: {
                disabledButtons: []
            }
        };
        /**
         * these are defined with the box-border class
         */
        static borderWidth = 1;
        static piecesName = ["top", "bottom", "left", "right"];

        targetEl: JQuery = null;
        overlayWrapper: JQuery = null;
        toolbox: JQuery = null;
        dimensions: Size = null;
        moduleObj: Modul = null;
        options: Options = null;
        gluedElement: JQuery = null;
        /**
         * @param htmlEl element around which to render the overlay
         * @param options list of attributes for configuration
         */
        constructor(htmlEl: JQuery, options: Options) {
            this.targetEl = htmlEl;
            this.options = $.extend({}, ModuleOverlay.defaultOptions, options);
            this.dimensions = {
                width: 0,
                height: 0
            };

            this._renderOverlay();
        }

        position() {
            this.overlayWrapper.position({
                my: "left top",
                at: "left top",
                of: this.targetEl,
                collision: 'none'
            });

            let topPiece = this.getPiece('top');
            this.toolbox
            .width(topPiece.outerWidth())
                /*@todo:find out why this fails some of the tine
            .position({
                my: "left top",
                at: "left top",
                of: topPiece,
                collision: 'none'
            })*/
            .css({
                left: -(this.options.thickness + ModuleOverlay.borderWidth * 2) + 'px',
                top: -(this.options.thickness + ModuleOverlay.borderWidth * 2) + 'px'
            });

            if (this.hasGluedElement()) {
                this.glueElementToBottom(this.gluedElement);
            }

        }
        show() {
            //there are some modules (like event calendar),
            // that after the module object initialization (the module overlay)
            // change their size and need this extra check when showing the overlay
            if (this.needsRefresh()) {
                this.resize();
            }
            this.overlayWrapper.fadeIn(300);
            this.position();
        }
        hide() {
            this.overlayWrapper.fadeOut(300);
        }
        hasGluedElement() {
            return this.gluedElement !== null && this.gluedElement.length > 0;
        }
        _renderOverlay() {
            this.overlayWrapper = $(
                '<div class="module-overlay-wrapper">'
                    + '<div class="overlay-pieces-wrapper">'
                        + '<div class="overlay-piece box-shadow top-piece">'
                            + '<div class="left-border-cover bg-primary"></div>'
                            + '<div class="right-border-cover bg-primary"></div>'
                            + '<div class="overlay-inner-piece bg-primary box-border"></div>'
                        + '</div>'
                        + '<div class="overlay-piece box-shadow left-piece">'
                            + '<div class="overlay-inner-piece bg-primary box-border"></div>'
                        + '</div>'
                        + '<div class="overlay-piece box-shadow right-piece">'
                            + '<div class="overlay-inner-piece bg-primary box-border"></div>'
                        + '</div>'
                        + '<div class="overlay-piece box-shadow bottom-piece">'
                            + '<div class="left-border-cover bg-primary"></div>'
                            + '<div class="right-border-cover bg-primary"></div>'
                            + '<div class="overlay-inner-piece bg-primary box-border"></div>'
                        + '</div>'
                    + '</div>'
                + '</div>'
            ).wrap('<div class="diye" ></div>');

            this.overlayWrapper.parent().appendTo(this.options.appendTo);
            this._renderToolbox();
            this.resize();
        }
        getOverlayElement() {
            return this.overlayWrapper;
        }
        needsRefresh() {
            if (this.dimensions.width !== this.targetEl.outerWidth() + this.options.addPadding * 2
                    || this.dimensions.height !== this.targetEl.outerHeight() + this.options.addPadding * 2) {
                return true;
            }

            return false;
        }
        /**
         *
         * @param iWidth inner width (border not included)
         * @param iHeight inner height (border not included)
         * @param position of the overlay vertical piece (left|right)
         */
        _resizeVerticalPiece(iWidth: number, iHeight: number, position: 'left'|'right' = 'left') {
            //to cover the box-shadow radius on the top and bottom where it meets the horizontal piece
            let extendHeight = 3;

            let blurRadius = ModuleOverlay.overlayShadowProperties.blurRadius;
            let borderWidth = ModuleOverlay.borderWidth;

            let overlayPiece = this.getPiece(position);

            let clipTop = extendHeight;
            let clipBottom = iHeight + extendHeight;

            let clipLeft: number;
            let clipRight: number;
            if (position === 'left') {
                clipLeft = - blurRadius;
                clipRight = 2 * borderWidth + iWidth;
            } else {
                clipLeft = 0;
                clipRight = 2 * borderWidth + iWidth + blurRadius;
            }

            overlayPiece.css({
                clip: 'rect(' + clipTop + 'px, ' + clipRight + 'px, ' + clipBottom + 'px, ' + clipLeft + 'px)',
                marginTop: -extendHeight
            });

            $('.overlay-inner-piece', overlayPiece).css({
                height: iHeight + extendHeight,
                width: iWidth
            });

            return overlayPiece;
        }
        /**
         *
         * @param iWidth inner width of the overlay piece (border not included)
         * @param iHeight inner height of the overlay piece (border not included)
         * @param position of the overlay horizontal piece (top|bottom)
         */
        _resizeHorizontalPiece(iWidth: number, iHeight: number, position: 'top'|'bottom' = 'bottom') {
            //to cover the box-shadow radius on the left and right where it meets the vertical piece
            let extendHeight = 3;

            let blurRadius = ModuleOverlay.overlayShadowProperties.blurRadius;
            let borderWidth = ModuleOverlay.borderWidth;

            let clipLeft = -blurRadius;
            let clipRight = iWidth + 2 * borderWidth + blurRadius;
            let overlayPiece = this.getPiece(position);

            let clipTop: number;
            let clipBottom: number;
            let coverTopPosition: number;

            if (position === 'top') {
                clipTop = - blurRadius;
                clipBottom = iHeight + 2 * borderWidth;
                coverTopPosition = iHeight + borderWidth;
            } else {
                clipTop = extendHeight;
                clipBottom = extendHeight + iHeight + 2 * borderWidth + blurRadius;
                coverTopPosition = extendHeight;
            }

            overlayPiece.css({
                clip: 'rect(' + clipTop + 'px, ' + clipRight + 'px, ' + clipBottom + 'px, ' + clipLeft + 'px)'
            });

            let sLeftPieceWidth = parseInt($('.left-piece .overlay-inner-piece', this.overlayWrapper).css('width'), 10);
            $('.left-border-cover', overlayPiece).css({
                width: sLeftPieceWidth,
                left: borderWidth,
                top: coverTopPosition,
                height: borderWidth
            });
            $('.right-border-cover', overlayPiece).css({
                width: sLeftPieceWidth,
                right: borderWidth,
                top: coverTopPosition,
                height: borderWidth
            });

            $('.overlay-inner-piece', overlayPiece)
                .height(iHeight)
                .width(iWidth);

            if (position === 'bottom') {
                $('.overlay-inner-piece', overlayPiece).css('margin-top', extendHeight);
                overlayPiece.css('margin-top', -extendHeight);
            } else {
                $('.overlay-inner-piece', overlayPiece).css('margin-bottom', extendHeight);
            }

            return overlayPiece;
        }
        resize() {
            this.dimensions = {
                width: this.targetEl.outerWidth() + this.options.addPadding * 2,
                height: this.targetEl.outerHeight() + this.options.addPadding * 2
            };

            let thickness = this.options.thickness;
            let borderWidth = ModuleOverlay.borderWidth;

            this._resizeVerticalPiece(thickness, this.dimensions.height, 'left').css({
                top: 0,
                left: -(thickness + 2 * borderWidth)
            });

            this._resizeVerticalPiece(thickness, this.dimensions.height, 'right').css({
                top: 0,
                left: this.dimensions.width
            });

            this._resizeHorizontalPiece(this.dimensions.width + thickness * 2 + 2 * borderWidth, thickness, 'top').css({
                top: -(thickness + 2 * borderWidth),
                left: -(thickness + 2 * borderWidth)
            });

            this._resizeHorizontalPiece(
                this.dimensions.width + thickness * 2 + 2 * borderWidth, thickness, 'bottom'
            ).css({
                top: this.dimensions.height,
                left: -(thickness + 2 * borderWidth)
            });

            this.overlayWrapper.find('.overlay-pieces-wrapper').css({
                width: this.dimensions.width,
                height: this.dimensions.height,
                top: -this.options.addPadding,
                left: -this.options.addPadding
            });

            this.resizeToolbox();
        }
        _renderToolbox() {
            this.toolbox = $(
                '<div class="module-toolbox-container">'
                    + '<div class="module-deletebar-wrapper ">'
                        + '<div class="module-deletebar v-toolbar box-border bg-primary">'
                            + '<a title="' + l10n.getString('module.deleteButtonLabel')
                                + '" class="toolbar-item ui-button-borderless tooldelete"> </a>'
                        + '</div>'
                    + '</div>'
                    + '<div class="module-movebar">'
                        + '<div class="v-toolbar bg-primary box-border">'
                            + '<span class="toolbar-item toolmove"'
                                + ' href="#" onclick="return false;" title="'
                                + l10n.getString('module.dragAndDropHandleLabel') + '"></span>'
                            + '<a class="toolbar-item toolduplicate not-sorting-handle"'
                                + ' href="javascript:void(0);" title="'
                                + l10n.getString('module.duplicateButtonLabel')
                                + '"></a>'
                            + '<a class="toolbar-item not-sorting-handle toolup"'
                                + ' href="javascript:void(0);" title="'
                                + l10n.getString('module.cannotBeMovedUpLabel')
                            + '"></a>'
                            + '<a class="toolbar-item not-sorting-handle tooldown"'
                                + ' href="javascript:void(0);" title="'
                                + l10n.getString('module.cannotBeMovedDownLabel')
                            + '"></a>'
                        + '</div>'
                    + '</div>'
                + '</div>'
            );

            //we add it to the same container as the module editor/and overlayWrapper
            //so they all share a common z-index stack
            this.toolbox.appendTo(this.overlayWrapper);
            this._updateDisabledToolboxButtons();
            this._updateToolboxVisibility();
        }
        resizeToolbox() {
            let moveBarWrap = this.toolbox.find('.module-movebar');
            moveBarWrap.css({
                paddingBottom: (Math.max(0, this.targetEl.outerHeight(), moveBarWrap.height()) * 0.5)
            });

            let deleteBarWrap = this.toolbox.find('.module-deletebar-wrapper');
            deleteBarWrap.css({
                paddingBottom: (Math.max(0, this.targetEl.outerHeight(), deleteBarWrap.height()) * 0.5)
            });
        }
        /**
         *
         * @param pieceName of the overlay piece (accepted values top|left|bottom|right)
         */
        getPiece(pieceName: string) {
            if ($.inArray(pieceName, ModuleOverlay.piecesName) === null) {
                return null;
            }

            return $('.' + pieceName + '-piece', this.overlayWrapper);
        }
        getToolbox() {
            return this.toolbox;
        }
        addContent(content: JQuery|any[]|Element|Text|string) {
            this.overlayWrapper.find('.overlay-pieces-wrapper').append(content);
        }
        _getToolboxButton(buttonId: string) {
            let toolbox = this.getToolbox();
            switch (buttonId) {
                case 'up':
                    return toolbox.find('.toolup');
                case 'down':
                    return toolbox.find('.tooldown');
                case 'duplicate':
                    return toolbox.find('.toolduplicate');
                case "move":
                    return toolbox.find('.toolmove');
                default:
                    return null;
            }
        }
        _updateDisabledToolboxButtons() {
            let buttonId: string;
            let button: JQuery;
            $('.toolbar-item.toolbar-item-disabled', this.getToolbox())
                .removeClass('toolbar-item-disabled');
            for (let i = 0; i < this.options.toolbox.disabledButtons.length; i++) {
                buttonId = this.options.toolbox.disabledButtons[i];
                button = this._getToolboxButton(buttonId);
                if (button) {
                    button.addClass('toolbar-item-disabled');
                }
            }
        }
        _updateToolboxVisibility() {
            let $toolbox = this.getToolbox();
            if (this.options.showToolbox) {
                $toolbox.show();
            } else {
                $toolbox.hide();
            }
        }
        setToolboxDisabledButtons(disabledButtons: string[]) {
            this.options.toolbox.disabledButtons = disabledButtons;
            this._updateDisabledToolboxButtons();
        }
        /**
         * @desc removes element glued to the bottom
         */
        removeElementFromBottom(element: JQuery) {
            //resize bottom piece
            this._resizeHorizontalPiece(
                this.dimensions.width + this.options.thickness * 2 + 2 * ModuleOverlay.borderWidth,
                this.options.thickness,
                'bottom');

            this.gluedElement = null;
            this.overlayWrapper.find('.module-overlay-after').hide();
        }
        /**
         * @desc positions the element at the bottom and makes it look
         * like a continuous piece by covering the place where they meet
         * makes the following assumptions: the element
         * has same border (width), and shadow, and it's sibling of the overlay wrapper
         */
        glueElementToBottom(element: JQuery) {
            let bottomPiece = this.getPiece('bottom');

            //if smaller resize
            if (element.width() <= bottomPiece.width()) {
                let newWidth = bottomPiece.width();
                element.width(newWidth);
            }

            element.position({
                my: "left top",
                at: "left bottom",
                of: bottomPiece,
                collision: 'none',
                offset: "0 0"
            });

            // set the left positioning if it's off screen and causes scrolling
            let elementTriggersXScroll = (element.offset().left + element.outerWidth()) > $(window).width();
            if (elementTriggersXScroll && (bottomPiece.outerWidth() < element.outerWidth())) {
                let rightPositionConfig = {
                    my: "right top",
                    at: "right bottom",
                    of: bottomPiece,
                    collision: 'none',
                    offset: "0 0"
                };
                element.position(rightPositionConfig);

                // Ensure it don't get out of viewport, or not too close to the edge of it
                if (parseInt(element.css('left'), 10) < 10) {
                    element.css('left', '10px');
                }

                // and make sure the element doesn't overlap with the move up/down/delete bar
                let toolbox = this.getToolbox().find('.module-movebar');
                let diff = (toolbox.offset().top + toolbox.height() + 12) - element.offset().top;
                if (diff > 0) {
                    //extend bottom piece
                    this._resizeHorizontalPiece(
                        bottomPiece.find('.overlay-inner-piece').innerWidth(),
                        bottomPiece.find('.overlay-inner-piece').innerHeight() + diff, 'bottom');
                    //and reposition
                    element.position(rightPositionConfig);
                }
            }

            let joinCover = this.overlayWrapper.find('.module-overlay-after');
            if (!joinCover.length) {
                joinCover = $('<div class="module-overlay-after overlay-piece bg-primary"></div>')
                    .appendTo(this.overlayWrapper);
            }

            //make it look continuous by covering it where they meet
            joinCover
                .show()
                //give it the width to cover the bottom border
                .width(bottomPiece.find('.overlay-inner-piece').width())
                .height(ModuleOverlay.borderWidth + ModuleOverlay.overlayShadowProperties.blurRadius)
                //put it above the element too
                .css('z-index', element.diy_zIndex(this.options.appendTo) + 1)
                .position({
                    my: "left top",
                    at: "left bottom",
                    of: bottomPiece,
                    collision: 'none',
                    offset: ModuleOverlay.borderWidth + " " +
                        (
                            -ModuleOverlay.overlayShadowProperties.blurRadius +
                            ModuleOverlay.borderWidth
                        )
                });

            this.gluedElement = element;
        }
    }



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/common/js/ModuleOverlay.ts
 **/